import { render } from "./Contact.vue?vue&type=template&id=7befb4e1&scoped=true&ts=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"

import "./Contact.vue?vue&type=style&index=0&id=7befb4e1&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7befb4e1"]])

export default __exports__